import { P, pub } from "@/lib/publicApi";
import { Printer, Download, ShieldCheck, Upload, Search } from "lucide-react";

// Electronic receipt shown immediately after a successful submission.
export const PublicReceipt = ({ result, onNavigate }) => {
  const filed = new Date(result.filed_at).toLocaleString("en-US", { dateStyle: "long", timeStyle: "medium" });
  const downloadPdf = () => {
    window.open(`${pub.defaults.baseURL}/cases/${result.case_number}/receipt.pdf?code=${result.access_code}`, "_blank");
  };
  return (
    <div data-testid="public-receipt" className="max-w-2xl mx-auto">
      <div className="border-2 rounded-sm overflow-hidden" style={{ borderColor: P.navy, background: P.card }}>
        <div className="px-6 py-4 flex items-center gap-3" style={{ background: P.navy }}>
          <ShieldCheck size={26} style={{ color: P.gold }} />
          <div>
            <div className="text-white font-bold text-lg">Your {result.kind} has been successfully received.</div>
            <div className="text-xs" style={{ color: "#B9C6D2" }}>MATCOM PUBLIC SAFETY — ELECTRONIC RECEIPT</div>
          </div>
        </div>
        <div className="p-6 space-y-3">
          {[["Case Number", result.case_number, "receipt-case-number"],
            ["Secure Access Code", result.access_code, "receipt-access-code"],
            ["Filed", filed, "receipt-filed"],
            ["Type", result.kind.charAt(0).toUpperCase() + result.kind.slice(1), "receipt-type"],
            ["Categories", result.categories.join(", "), "receipt-categories"],
            ["Status", "Received", "receipt-status"]].map(([k, v, tid]) => (
            <div key={k} className="flex items-start gap-4 pb-2 border-b" style={{ borderColor: P.line }}>
              <div className="w-44 shrink-0 text-[11px] font-bold uppercase tracking-wider pt-0.5" style={{ color: P.dim }}>{k}</div>
              <div data-testid={tid} className={`text-sm ${k === "Case Number" || k === "Secure Access Code" ? "font-mono font-bold text-lg" : ""}`} style={{ color: k === "Secure Access Code" ? P.red : P.ink }}>{v}</div>
            </div>
          ))}
          <div className="rounded-sm px-4 py-3 text-sm font-semibold" style={{ background: "#FBF3E2", color: "#7A5A0E", border: `1px solid ${P.gold}` }}>
            Save your Case Number and Secure Access Code — they are required to check status, respond, or upload evidence. They will not be shown again.
          </div>
        </div>
        <div className="px-6 pb-6 flex flex-wrap gap-3">
          <button data-testid="receipt-print-btn" onClick={() => window.print()} className="flex items-center gap-2 px-4 py-2.5 text-sm font-bold text-white rounded-sm hover:opacity-90" style={{ background: P.navy }}><Printer size={15} /> PRINT RECEIPT</button>
          <button data-testid="receipt-download-btn" onClick={downloadPdf} className="flex items-center gap-2 px-4 py-2.5 text-sm font-bold rounded-sm hover:opacity-90" style={{ background: P.gold, color: "#fff" }}><Download size={15} /> DOWNLOAD PDF</button>
          <button data-testid="receipt-evidence-btn" onClick={() => onNavigate("/public/evidence")} className="flex items-center gap-2 px-4 py-2.5 text-sm font-bold rounded-sm border-2 hover:bg-black/5" style={{ borderColor: P.navy, color: P.navy }}><Upload size={15} /> UPLOAD EVIDENCE</button>
          <button data-testid="receipt-track-btn" onClick={() => onNavigate("/public/case")} className="flex items-center gap-2 px-4 py-2.5 text-sm font-bold rounded-sm border-2 hover:bg-black/5" style={{ borderColor: P.navy, color: P.navy }}><Search size={15} /> CHECK CASE STATUS</button>
        </div>
      </div>
    </div>
  );
};
